import React, {useState, useEffect} from 'react';
import Dashboard from '../dashboard/dashboard';
import FieldReport from '../fieldReport/fieldReport';
import './dropdown.scss';
import Header from '../Header/Header.js'
function Selector() {
    const [depots, setDepots] = useState([]);
    const [selected, setSelected] = useState('All');
    const [allItems, setAllItems] = useState(null);
    const [allIssues, setAllIssues] = useState(null);
    const [reload, setReload] = useState(false);
    const [view, setView] = useState('dashboard');

    function handleIssueCreated(newIssue) {
        setAllIssues((previous) => previous ? [newIssue, ...previous] : [newIssue]);
    }

    function handleVehicleStatusChanged(vehicleId, status) {
        setAllItems((previous) => previous
            ? previous.map((vehicle) => vehicle.id === vehicleId
                ? { ...vehicle, vehicle_status_id: status.id, vehicle_status_name: status.name }
                : vehicle)
            : previous);
    }


    const processOrders = (vehicles, allOrders) => {
        const orders = allOrders.filter((order) => order && order.number);

        return vehicles.map((vehicle) => {
          const ordersForVehicle = orders
            .filter((order) => order.vehicle_name === vehicle.name)
            .map((order) => ({
              order_number: order.number.replace(/#/g, ''),
              url: `https://secure.fleetio.com/${process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN}/work_orders/${order.number.replace(/#/g, '')}`,
              issued_by: order.issued_by_name,
              issued_at: order.issued_at,
              // Line items come embedded in the v1 work_orders response
              items: (order.work_order_line_items || [])
                .map((lineItem) => lineItem.item_name || lineItem.description)
                .filter(Boolean)
            }));
      
          return {
            ...vehicle,
            orders: ordersForVehicle,
          };
        });
    };
    
    function getVehicleNames(vehicles) {
        let names = [];
        for (let i = 0; i < vehicles.length; i++) {
          if (!isNaN(Number(vehicles[i]["name"]))) {
            names.push(vehicles[i]["name"]);
          }
        }
        return names.join(",");
    }
    
    
    
    function filterObjectsByVehicleName(arrStrings, arrObjects) {
        return arrObjects.filter(obj => arrStrings.includes(obj.vehicle_name));
    }

    // Handles both classic page-numbered arrays and the newer cursor-paginated
    // {records, next_cursor} envelope, depending on the API version of the token.
    async function fetchAllPages(url, options) {
        let allData = [];
        let cursor = null;
        let page = 1;
        let useCursor = false;

        while (true) {
            const pageUrl = cursor
                ? url + 'start_cursor=' + encodeURIComponent(cursor)
                : url + 'page=' + page;
            const response = await fetch(pageUrl, options);
            if (response.status === 429) {
              console.log("API rate limit reached, waiting before retrying...");
              const retryAfter = Number(response.headers.get('Retry-After'));
              await new Promise(resolve => setTimeout(resolve, retryAfter ? retryAfter * 1000 : 30000));
              continue;
            }
            if (!response.ok) {
              console.error(`Request to ${url} failed with status ${response.status}`);
              break;
            }
            const body = await response.json();

            let records;
            if (Array.isArray(body)) {
              records = body;
            } else if (body && Array.isArray(body.records)) {
              records = body.records;
              useCursor = true;
            } else {
              break;
            }
            allData = allData.concat(records);

            if (useCursor) {
              if (!body.next_cursor) break;
              cursor = body.next_cursor;
            } else {
              if (records.length === 0) break;
              const totalPages = Number(response.headers.get('X-Pagination-Total-Pages'));
              if (totalPages && page >= totalPages) break;
              page++;
            }
        }

        return allData;
    }

    // Newer API versions attach the vehicle as `vehicle` (not `asset`), prefix
    // numbers with '#', and title issues with `summary`; normalize both shapes.
    function normalizeIssues(issues) {
        return issues
            // Safety net: only open issues, whichever API version served them
            .filter((issue) => (issue.state || '').toLowerCase() === 'open')
            .map((issue) => ({
                ...issue,
                number: String(issue.number === undefined || issue.number === null ? '' : issue.number).replace(/#/g, ''),
                summary: issue.summary || issue.name,
                asset: issue.asset || issue.vehicle || {},
                custom_fields: issue.custom_fields || {}
            }));
    }

    useEffect(() => {
        const interval = setInterval(() => {
          // update the state every 15 minutes
          console.log('reloading');
          setReload(!reload);
        }, 15 * 60 * 1000); // 15 minutes in milliseconds
    
        return () => clearInterval(interval);
      }, [reload]);
  
    useEffect(() => {
      console.log('fetching Fleetio data');
      async function fetchData() {
        const options = {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + process.env.REACT_APP_FLEETIO_AUTHORIZATION_TOKEN,
            'Account-Token': process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN
            }
          };
        
        // Vehicles + work orders first so the dashboard can render quickly;
        // the (much larger) issues list streams in afterwards.
        const fleetData = await fetchAllPages(`https://secure.fleetio.com/api/v1/vehicles?per_page=100&`, options);
        const vehicleList = await getVehicleNames(fleetData);
        const workData = await fetchAllPages(`https://secure.fleetio.com/api/v1/work_orders?q[work_order_status_name_in_s]=Open,Pending&q[vehicle_name_in_s]=${vehicleList}&q[constum_field_breakdown_or_accident_in_s]=Breakdown,Accident&per_page=100&`, options);
        setAllItems(processOrders(fleetData, workData));

        // scope=opened filters on older API versions; filter[state][eq]=open on newer ones
        const issuesData = await fetchAllPages(`https://secure.fleetio.com/api/v2/issues?&scope=opened&filter[state][eq]=open&includes=custom_fields,asset&per_page=100&`, options);
        setAllIssues(normalizeIssues(issuesData));
      }
      fetchData();
      }, [reload]);




    useEffect(() => {
        async function fetchDepots() {
            const options = {
                method: 'GET',
                headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token ' + process.env.REACT_APP_FLEETIO_AUTHORIZATION_TOKEN,
                'Account-Token': process.env.REACT_APP_FLEETIO_ACCOUNT_TOKEN
                }
              };
            try {
                const groups = await fetchAllPages('https://secure.fleetio.com/api/v1/groups?', options);
                setDepots(groups);
            } catch (error) {
                console.error('Failed to fetch depots', error);
            }
        }
        fetchDepots()

    }, []);


        return (<div className='app-shell'>
            <Header change={reload}>
                <nav className='view-switch'>
                    <button className={view === 'dashboard' ? 'active' : ''} onClick={() => setView('dashboard')}>Dashboard</button>
                    <button className={view === 'field' ? 'active' : ''} onClick={() => setView('field')}>Field Report</button>
                </nav>
                {view === 'dashboard' && (
                    <div className="dropdown">
                        <span className="choose">Depot</span>
                        <select value={selected} onChange={(e) => {setSelected(e.target.value)}}>
                            <option value="All">All</option>
                            {depots
                                .filter((depotGroup) => allItems && allItems.some((vehicle) => (vehicle.group_name || '').includes(depotGroup.name)))
                                .map((item, index) => {
                                    return <option key={index} value={item.name}>{item.name}</option>
                                })}
                        </select>
                    </div>
                )}
            </Header>
            {view === 'dashboard'
                ? <Dashboard depot={selected} allItems={allItems} allIssues={allIssues}/>
                : <FieldReport vehicles={allItems} issues={allIssues} onIssueCreated={handleIssueCreated} onVehicleStatusChanged={handleVehicleStatusChanged}/>
            }
        </div>
        );
    }


export default Selector;